import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { IMAGES } from "../../../assets/images";
import { useState } from "react";
import { useEffect, useRef } from "react";

const ImageSlider = ({ swiperRef }) => {
  const localSwiperRef = useRef(null);
  useEffect(() => {
    if (localSwiperRef.current) {
      swiperRef.current = localSwiperRef.current.swiper;
    }
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  const totalSlides = 6;
  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex % totalSlides);
  };
  return (
    <div className="flex justify-center items-center flex-col w-full mb-4">
      <Swiper
        ref={localSwiperRef}
        modules={[Pagination, Autoplay]}
        spaceBetween={10}
        slidesPerView={1}
        pagination={{ clickable: false, type: "none" }}
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        allowTouchMove={false}
        className="w-full rounded-2xl overflow-hidden mb-3"
        onSlideChange={handleSlideChange}
      >
        <SwiperSlide>
          <img
            src={IMAGES.healthBannerOne}
            loading="lazy"
            alt="Slide 1"
            className="w-full h-[324px] object-cover rounded-2xl"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={IMAGES.healthBannerTwo}
            loading="lazy"
            alt="Slide 2"
            className="w-full h-[324px] object-cover rounded-2xl"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={IMAGES.healthBannerThree}
            loading="lazy"
            alt="Slide 3"
            className="w-full h-[324px] object-cover rounded-2xl"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={IMAGES.healthBannerFour}
            loading="lazy"
            alt="Slide 4"
            className="w-full h-[324px] object-cover rounded-2xl"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={IMAGES.healthBannerFive}
            loading="lazy"
            alt="Slide 5"
            className="w-full h-[324px] object-cover rounded-2xl"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={IMAGES.healthBannerSix}
            loading="lazy"
            alt="Slide 6"
            className="w-full h-[324px] object-cover rounded-2xl"
          />
        </SwiperSlide>
      </Swiper>
      <div className="flex gap-2">
        {Array.from({ length: 6 }).map((_, index) => (
          <span
            key={index}
            className={`w-7 h-2 rounded-md ${activeIndex === index ? "bg-[#0133A4] border-none" : "bg-transparent border-[#0133A4] border-[1px]"}`}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
